export const PrecisionGame_DA = {
  precisionGame: {
    headline: "Test din præcision",
    objective: "Kan du ramme {{objective}} ved at klikke på knappen?",
    totalAttempts: "Samlede forsøg",
    start: "Start",
    stop: "Stop",
    youWon: "Du vandt",
    congrats: "Tillykke! Godt gået!",
    leaderboard: {
      headline: "Vindere",
      none: "Ingen har nået leaderboardet endnu.",
      username: "Brugernavn",
      attempts: "Forsøg",
    },
    honorable: {
      headline: "Værd at nævne",
      none: "Ingen er kommet tæt på endnu!",
    },
    toast: {
      success: "Dit resultat er blevet tilføjet!",
      error: "Der opstod en fejl: ",
    },
  },
};
